// extracted by mini-css-extract-plugin
module.exports = {"label":"Xxe68","flag":"ixEpp","text":"JnK4L"};